import stl from "./AsideFooter.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";

function AsideFooter({
  setFilterOnMobile,
  count,
  selectedFiltersCount
}) {
  const { t } = useTranslation();
  return (
    <>
      {count == 0 && selectedFiltersCount > 0 && (
        <div className={stl.noteContainer}>
          <strong>{t("حاول إزالة بعض الفلاتر", { ns: "web_search" })}</strong>{" "}
          <span>{t("لإيجاد نتائج بحث مطابقة", { ns: "web_search" })}</span>
        </div>
      )}
      <div
        className={[stl.container, "m-show"].join(" ")}
        id="clickMeToCloseFilter"
        onClick={() => {
          setFilterOnMobile(false);

          document.body.style.overflow = "";
        }}
      >
        <strong>{t("أظهر النتائج", { ns: "web_search" })}</strong>
        <div>
          <img
            width={18}
            height={12}
            src={CDN_LINK + "/assets/images/arrShow.svg"}
            alt="arrow"
          />
        </div>
      </div>
    </>
  );
}

export default AsideFooter;
